module.exports = __webpack_public_path__ + "img/btn-chat-img.ab97069a.png";